import appNotificationService from "./utils/appNotificationService";

import EventBus from "src/services/utils/appEventBusService";
import {useAuthStore} from "src/stores/authStore";

import BusEnum from "src/enums/BusEnum"
import AppEnvVariablesService from "src/services/utils/appEnvService";
import appConsoleService from "src/services/utils/appConsoleService";

class WebSocketService {

  getInstance() {
    if (!this.wss) {
      this.wss = new WebSocketInstance()
    }
    return this.wss
  }
}

class WebSocketInstance {

  constructor() {
    this.attempts = 0
    this.shouldReconnect = true
    this.socket = undefined
    this.currentWsId = undefined
  }

  connect(force = false) {
    const ref = this;
    this.attempts++

    if (!this.socket || force) {

      const APP_PROTOCOL = AppEnvVariablesService.getEnv("APP_PROTOCOL")
      const APP_DOMAIN = AppEnvVariablesService.getEnv("APP_DOMAIN")

      let WS_URL = APP_PROTOCOL + "://" + APP_DOMAIN + "/websockets"

      if (WS_URL.startsWith("https")) {
        WS_URL = WS_URL.replaceAll("https", "wss")
      } else {
        WS_URL = WS_URL.replaceAll("http", "ws")
      }
      this.currentWsId=this.getUniqueID()
      const authStore = useAuthStore()
      if(authStore.isLoggedIn && authStore.currentUser) {
        this.socket = new WebSocket(WS_URL + "?wsId=" + this.currentWsId+"&token="+ authStore.currentUser.accessToken);
      }
      else{
        this.socket = new WebSocket(WS_URL + "?wsId=" + this.currentWsId+"&token=unregistered");
      }

      // Handle events
      this.socket.onmessage = (event) => {
        try {
          let data = JSON.parse(event.data)
          if (data.cmd !== BusEnum.KEEP_ALIVE) {
            //appConsoleService.log(data.cmd)
            //appConsoleService.log(data)
          }
          EventBus.emit(data.cmd, data)
        } catch (error) {
          appConsoleService.log(error.message)
        }
      }
      // Connexion fermée (redémarrage du backend, coupure réseau) : reconnexion forcée, sinon connect()
      // ne fait rien tant que this.socket existe et l'onglet restait sourd aux diffusions (mises à jour,
      // notifications) jusqu'à son rechargement. Délai croissant, 1 s à 30 s.
      this.socket.onclose = function () {
        if (!ref.shouldReconnect) return
        const delay = Math.min(1000 * 2 ** Math.min(ref.attempts - 1, 5), 30000)
        setTimeout(() => ref.connect(true), delay);
      };

      this.socket.onerror = function (err) {
        appConsoleService.error('WebSocketService', err)
        ref.socket.close();
      };

      this.socket.onopen = function () {
        ref.attempts = 0
        appConsoleService.info('WebSocketService', "Connection opened at :" + WS_URL);
      };

    }
  }

  /** Nouvelle connexion, avec le jeton de l'utilisateur connecté : après la connexion (login), la socket
   *  ouverte au chargement sans jeton ne recevrait ni notifications ni diffusions destinées à l'utilisateur */
  reconnect() {
    this.shouldReconnect = false
    if (this.socket) this.socket.close()
    this.shouldReconnect = true
    this.attempts = 0
    this.connect(true)
  }

  sendMessage(message) {
    try {
      if (this.socket === undefined) {
        this.connect()
      }
      if (this.socket.readyState === this.socket.OPEN) {
        const store = useAuthStore()
        if (store.currentUser) {
          this.socket.send(JSON.stringify({
            cmd: BusEnum.CHAT,
            token: store.currentUser.accessToken,
            data: message
          }));
        }
      } else {
        appNotificationService.pushWarning(this.socket.readyState)
        this.connect()
      }
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  sendHeartBeat() {
    try {
      if (this.socket === undefined) {
        this.connect()
      }
      if (this.socket.readyState === this.socket.OPEN) {

        this.socket.send(JSON.stringify({
          cmd: BusEnum.HEARTBEAT,
          wsId: this.currentWsId
        }));

      } else {
        appNotificationService.pushWarning(this.socket.readyState)
        this.connect()
      }
    } catch (error) {
      appNotificationService.pushError(error);
    }
  }

  getUniqueID() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4();
  };

  getCurrentWsId()  {
    return this.currentWsId
  }
}


export default new WebSocketService;
